import React from 'react';
import PropTypes from 'prop-types';

import Item from 'components/Members/Wallet/Popup/Item';
import currencyFormat from 'components/Widgets/currencyFormat';

export default function Items({ invoice }) {
  return (
    <div className="items">
      <Item
        key="employee-total-cost"
        title="Total Cost"
        value={currencyFormat(
          invoice.attributes.employee_total_cost,
          { currency: invoice.attributes.currency },
        )}
      />
      <Item
        key="assessments"
        title="Fully Paid"
        value={currencyFormat(
          invoice.attributes.total_paid,
          { currency: invoice.attributes.currency },
        )}
      />

      <hr />
      <div className="d-flex  justify-content-between">
        <div>Total</div>
        <div className="value">
          {currencyFormat(
            invoice.attributes.total,
            { currency: invoice.attributes.currency },
          )}
        </div>
      </div>

    </div>
  );
}

Items.propTypes = {
  invoice: PropTypes.object.isRequired,
};
